import { BookingEventSchemas as e } from "../verticals/booking/BookingEventPayloads.mjs";
import { PaymentEventSchemas as t } from "../verticals/payments/PaymentEventPayloads.mjs";
import { MarketingEventSchemas as n } from "../verticals/marketing/MarketingEventPayloads.mjs";
import { AuthEventSchemas as r } from "../verticals/auth/AuthEventPayloads.mjs";
import { HostEventSchemas as i } from "../verticals/host/HostEventPayloads.mjs";
import { PricingEventSchemas as a } from "../verticals/pricing/PricingEventPayloads.mjs";
import { ReferralEventSchemas as o } from "../verticals/referral/ReferralEventPayloads.mjs";
//#region src/registry/EventSchemas.ts
var s = {
	...e,
	...t,
	...n,
	...r,
	...i,
	...a,
	...o
};
//#endregion
export { s as EventSchemas };
